import { styled } from "@mui/material";
import { colorNames } from "../Theme/Colors";
const colors = colorNames();

export const RolePermissionWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        margin-top: 20px;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .add_btn {
            position: relative;
            margin-left: auto;

            a {
                position: relative;
                width: 200px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-decoration: none;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                color: ${colors.customColors.whiteColor};
                border: none;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;

                i {
                    margin-right: 8px;
                    font-size: 12px;
                }

                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .role_levels {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 15px;

        .box_items {
            position: relative;
            width: 100%;
            display: flex;
            padding: 5px;
            flex-wrap: wrap;

            .role_item {
                position: relative;
                width: 25%;
                max-width: 302.75px;
                padding: 10px;

                .item_inner {
                    position: relative;
                    width: 100%;
                    padding: 12px;
                    padding-left: 15px;
                    background: ${colors.customColors.whiteColor};
                    border: 1px solid ${colors.customColors.borderColor};
                    border-left: 4px solid ${colors.customColors.blueColor1};
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                    .inner_top {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        padding-bottom: 8px;
                        border-bottom: 1px solid ${colors.customColors.borderColor};

                        a {
                            position: relative;
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: ${colors.customColors.blueColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                            color: ${colors.customColors.blueColor1};
                            text-decoration: none;
                            cursor: pointer;
                        }

                        h6 {
                            position: relative;
                            padding-left: 6px;
                            max-width: calc(100% - 85px);
                            font-size: 13.5px;
                            font-style: italic;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor};
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        span {
                            position: relative;
                            width: max-content;
                            display: flex;
                            font-size: 10px;
                            color: ${colors.customColors.orangeColor};
                            margin-top: 2px;
                            background: ${colors.customColors.yellowColorLight};
                            border-radius: 25px;
                            padding: 3px 15px;
                            margin-left: auto;
                            font-weight: 500;
                        }
                    }

                    .inner_btn {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-top: 8px;
                        justify-content: flex-end;

                        button {
                            position: relative;
                            width: max-content;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                            padding: 0 12px;

                            &.edit {
                                background: ${colors.customColors.greenColorLight};
                                color: ${colors.customColors.greenColor};
                                font-size: 10px;
                                cursor: pointer;
                                font-weight: 500;
                                border-bottom-left-radius: 4px;
                                border-top-left-radius: 4px;

                                i {
                                    font-size: 11px;
                                    margin-right: 8px;
                                }
                            }

                            &.delete {
                                background: ${colors.customColors.redColorLight};
                                color:  ${colors.customColors.redColor};
                                font-size: 10px;
                                cursor: pointer;
                                border-top-right-radius: 4px;
                                border-bottom-right-radius: 4px;
                            }
                        }
                    }
                }
            }

            .empty_box {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 0 10px;
                margin-top: 70px;

                img {
                    position: relative;
                    width: 300px;
                    opacity: 0.5;
                }

                p {
                    position: relative;
                    font-size: 15px;
                    margin-top: 10px;
                    color: ${colors.customColors.blackColor3};
                }
            }
        }
    }
`;

export const AddRolePermissionWrapper = styled('div')`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        padding: 0 15px;

        .left_sec {
            position: relative;
            padding-right: 40px;
            display: flex;
            flex-direction: column;

            h2 {
                position: relative;
                font-size: 21px;
                font-weight: 600;
                color: ${colors.customColors.blackColor};
                font-family: "SUSE", sans-serif;
            }

            p {
                position: relative;
                margin-top: 5px;
                font-size: 14px;
                color: ${colors.customColors.blackColor2};
                font-weight: 400;
            }
        }

        .btn_sec {
            position: relative;
            margin-left: auto;
            display: flex;
            align-items: center;

            button {
                position: relative;
                height: 35px;
                display: flex;
                align-items: center;
                padding: 0 30px;
                border: none;
                font-size: 13px;
                font-weight: 500;
                border-radius: 6px;
                cursor: pointer;
                transition: all 0.5s ease;

                &:first-of-type {
                    background: ${colors.customColors.lightBackground2};
                    color: ${colors.customColors.blackColor1};
                    margin-right: 15px;
                }
                
                &:last-of-type {
                    background: ${colors.customColors.greenColor};
                    color: ${colors.customColors.whiteColor};

                    i {
                        margin-right: 5px;
                    }
                }

                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }

                &:disabled {
                    opacity: 0.4;
                    transition: all 0.5s ease;
                    cursor: not-allowed;
                }
            }
        }
    }

    .page_content_sec {
        position: relative;
        width: 100%;
        height: calc(100% - 74px);
        display: flex;

        .sec_inner {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            padding: 0 5px;
            padding-bottom: 8px;

            .left_sec {
                position: relative;
                width: 290px;
                height: 100%;
                padding: 0 10px;
                display: flex;
                overflow-y: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .left_inner {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .left_box {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding: 15px;
                        border-radius: 8px;
                        margin-top: 20px;
                        box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                                -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                        &:last-of-type {
                            margin-bottom: 0;
                        }

                        .box_head {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;

                            .head_img {
                                position: relative;
                                width: 20px;
                                height: auto;
                                display: flex;

                                img {
                                    position: relative;
                                    width: 100%;
                                }
                            }

                            h5 {
                                position: relative;
                                width: calc(100% - 20px);
                                padding-left: 10px;
                                display: flex;
                                font-size: 15px;
                                font-weight: 500;
                                color: ${colors.customColors.blackColor};
                            }
                        }

                        .box_items {
                            position: relative;
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            margin-top: 15px;

                            .input_box {
                                position: relative;
                                width: 100%;
                                margin-bottom: 15px;

                                input {
                                    position: relative;
                                    width: 100%;
                                    height: 37px;
                                    font-size: 12px;
                                    border-radius: 5px;
                                    padding: 5px 15px;
                                    outline: none;
                                    border: none;
                                    margin-top: 3px;
                                    background: ${colors.customColors.lightBackground3};
                                }

                                span {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blackColor2};

                                    p {
                                        color: ${colors.customColors.redColor};
                                        margin-left: 2px;
                                    }
                                }
                            }

                            .info_box {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: flex-start;
                                padding: 15px;
                                background: ${colors.customColors.blueColorLight};
                                border-radius: 8px;

                                a {
                                    position: relative;
                                    font-size: 14px;
                                    text-decoration: none;
                                    color: ${colors.customColors.blueColor1};
                                }

                                p {
                                    position: relative;
                                    width: calc(100% - 12px);
                                    padding-left: 8px;
                                    font-size: 11px;
                                    font-weight: 400;
                                    color: ${colors.customColors.blueColor2};
                                }
                            }

                            .status_box {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: center;
                                padding: 10px;
                                background: ${colors.customColors.lightBackground3};
                                border-radius: 5px;

                                .status_left {
                                    position: relative;
                                    width: calc(100% - 40px);
                                    padding-right: 10px;
                                    display: flex;
                                    flex-direction: column;

                                    p {
                                        position: relative;
                                        font-size: 12px;
                                        color: ${colors.customColors.blackColor};
                                        font-weight: 500;
                                        line-height: 1;
                                    }

                                    span {
                                        position: relative;
                                        font-size: 10px;
                                        color: ${colors.customColors.blackColor2};
                                        margin-top: 5px;
                                        line-height: 1;
                                    }
                                }

                                .status_right {
                                    position: relative;
                                    width: 40px;
                                    display: flex;

                                    .toggle_bar {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        justify-content: flex-start;

                                        input[type="checkbox"] {
                                            display: none;
                                        }

                                        label {
                                            position: relative;
                                            width: 45px;
                                            height: 21px;
                                            background: ${colors.customColors.whiteColor2};
                                            border-radius: 25px;
                                            padding: 3px;
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                            transition: all 0.5s ease;

                                            span {
                                                position: relative;
                                                width: 15px;
                                                height: 100%;
                                                background: ${colors.customColors.whiteColor};
                                                border-radius: 50%;
                                                transition: all 0.5s ease;
                                            }
                                        }

                                        input[type="checkbox"]:checked ~ label {
                                            background: ${colors.customColors.greenColor1};
                                            transition: all 0.5s ease;
                                        }

                                        input[type="checkbox"]:checked ~ label span {
                                            transform: translateX(19px);
                                            transition: all 0.5s ease;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .right_sec {
                position: relative;
                width: calc(100% - 290px);
                height: 100%;
                padding: 0 10px;
                display: flex;
                margin-top: 20px;

                .right_inner {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    border-radius: 8px;
                    box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                    .right_head {
                        position: relative;
                        width: 100%;
                        display: flex;
                        padding: 15px 20px;
                        padding-right: 30px;
                        border-bottom: 1px solid ${colors.customColors.borderColor};

                        .head_left_sec {
                            position: relative;
                            display: flex;
                            flex-direction: column;

                            .top_sec {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: center;

                                .sec_img {
                                    position: relative;
                                    width: 20px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    img {
                                        position: relative;
                                        width: 100%;
                                    }
                                }

                                h5 {
                                    position: relative;
                                    margin-left: 8px;
                                    font-size: 14px;
                                    color: ${colors.customColors.blackColor1};
                                    font-weight: 500;
                                }
                            }

                            p {
                                position: relative;
                                width: 100%;
                                display: flex;
                                font-size: 11px;
                                color: ${colors.customColors.blackColor2};
                                margin-top: 5px;
                            }
                        }

                        .head_right_sec {
                            position: relative;
                            margin-left: auto;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            li {
                                position: relative;
                                list-style: none;
                                display: flex;
                                align-items: center;
                                color: ${colors.customColors.blackColor3};
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 12px;
                                font-weight: 500;

                                input[type="checkbox"] {
                                    display: none;
                                }

                                label {
                                    position: relative;
                                    cursor: pointer;
                                    line-height: 1;
                                    display: flex;
                                    align-items: center;

                                    .check_box {
                                        position: relative;
                                        width: 15px;
                                        height: 15px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        border-radius: 4px;
                                        margin-right: 5px;
                                        cursor: pointer;
                                        transition: all 0.4s ease;

                                        i {
                                            font-size: 10px;
                                            opacity: 0;
                                            transition: all 0.4s ease;
                                        }
                                    }
                                }

                                input[type="checkbox"]:checked ~ label {

                                    .check_box {
                                        background: ${colors.customColors.blackColor3};
                                        transition: all 0.4s ease;

                                        i {
                                            opacity: 1;
                                            color: ${colors.customColors.whiteColor};
                                            transition: all 0.4s ease;
                                        }
                                    }
                                }

                                &:first-of-type {
                                    color: ${colors.customColors.blueColor2};
                                    margin-right: 20px;

                                    label {
                                        .check_box {
                                            border: 1px solid ${colors.customColors.blueColor2};
                                        }
                                    }

                                    input[type="checkbox"]:checked ~ label {

                                        .check_box {
                                            background: ${colors.customColors.blueColor2};
                                            transition: all 0.4s ease;

                                            i {
                                                opacity: 1;
                                                color: ${colors.customColors.whiteColor};
                                                transition: all 0.4s ease;
                                            }
                                        }
                                    }
                                }
                            }

                            a {
                                position: relative;
                                display: flex;
                                align-items: center;
                                color: ${colors.customColors.blackColor3};
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 12px;
                                font-weight: 500;

                                li {
                                    position: relative;
                                    list-style: none;
                                    margin-right: 5px;
                                    display: flex;
                                    align-items: center;
                                    color: ${colors.customColors.blackColor3};
                                    text-decoration: none;
                                    cursor: pointer;
                                    font-size: 12px;
                                    font-weight: 500;

                                    input[type="checkbox"] {
                                        display: none;
                                    }

                                    label {
                                        position: relative;
                                        cursor: pointer;
                                        line-height: 1;
                                        display: flex;
                                        align-items: center;

                                        .check_box {
                                            position: relative;
                                            width: 15px;
                                            height: 15px;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            border: 1px solid ${colors.customColors.borderColor};
                                            border-radius: 4px;
                                            cursor: pointer;
                                            transition: all 0.4s ease;

                                            i {
                                                font-size: 14px;
                                                opacity: 0;
                                                transition: all 0.4s ease;
                                            }
                                        }
                                    }

                                    input[type="checkbox"]:checked ~ label {

                                        .check_box {
                                            background: ${colors.customColors.blackColor3};
                                            transition: all 0.4s ease;

                                            i {
                                                opacity: 1;
                                                color: ${colors.customColors.whiteColor};
                                                transition: all 0.4s ease;
                                            }
                                        }
                                    }
                                }

                                &:first-of-type {
                                    color: ${colors.customColors.blueColor2};
                                    margin-right: 20px;

                                    li {
                                        label {
                                            .check_box {
                                                border: 1px solid ${colors.customColors.blueColor2};
                                            }
                                        }

                                        input[type="checkbox"]:checked ~ label {

                                            .check_box {
                                                background: ${colors.customColors.blueColor2};
                                                transition: all 0.4s ease;

                                                i {
                                                    opacity: 1;
                                                    color: ${colors.customColors.whiteColor};
                                                    transition: all 0.4s ease;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .right_body_sec {
                        position: relative;
                        width: 100%;
                        height: calc(100% - 66px);
                        display: flex;
                        padding: 15px 0;

                        .body_inner {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            padding: 0 15px;
                            overflow-y: auto;
                            scrollbar-width: none;
                            -ms-overflow-style: none;

                            &::-webkit-scrollbar {
                                display: none;
                            }

                            .role_box {
                                position: relative;
                                margin: 7.5px 0;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                border: 1px solid ${colors.customColors.borderColor};
                                border-radius: 8px;
                                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2};

                                &:first-of-type {
                                    margin-top: 0;
                                }

                                .top_part {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    padding: 10px 15px;
                                    cursor: pointer;
                                    border-radius: 8px 8px 0 0;
                                    transition: all 0.5s ease;

                                    .top_left {
                                        position: relative;
                                        display: flex;
                                        align-items: center;

                                        .role_icon {
                                            position: relative;
                                            width: 35px;
                                            height: 35px;
                                            border-radius: 5px;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            background: ${colors.customColors.blueColorLight};

                                            i {
                                                font-size: 14px;
                                                color: ${colors.customColors.blueColor1};
                                            }
                                        }

                                        p {
                                            position: relative;
                                            font-size: 13px;
                                            color: ${colors.customColors.blackColor};
                                            font-weight: 500;
                                            margin-left: 8px;
                                        }
                                    }

                                    .top_btns {
                                        position: relative;
                                        display: flex;
                                        margin-left: auto;

                                        li {
                                            position: relative;
                                            list-style: none;
                                            margin-right: 5px;
                                            cursor: pointer;
                                            font-size: 12px;
                                            font-weight: 500;
                                            color: ${colors.customColors.blackColor3};

                                            input[type="checkbox"] {
                                                display: none;
                                            }

                                            label {
                                                position: relative;
                                                cursor: pointer;
                                                line-height: 1;
                                                display: flex;
                                                align-items: center;

                                                .check_box {
                                                    position: relative;
                                                    width: 15px;
                                                    height: 15px;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    border: 1px solid ${colors.customColors.borderColor};
                                                    border-radius: 4px;
                                                    margin-right: 5px;
                                                    cursor: pointer;
                                                    transition: all 0.4s ease;

                                                    i {
                                                        font-size: 10px;
                                                        opacity: 0;
                                                        transition: all 0.4s ease;
                                                    }
                                                }
                                            }

                                            input[type="checkbox"]:checked ~ label {

                                                .check_box {
                                                    background: ${colors.customColors.blackColor3};
                                                    transition: all 0.4s ease;

                                                    i {
                                                        opacity: 1;
                                                        color: ${colors.customColors.whiteColor};
                                                        transition: all 0.4s ease;
                                                    }
                                                }
                                            }

                                            &:first-of-type {
                                                color: ${colors.customColors.blueColor2};
                                                margin-right: 20px;

                                                label {
                                                    .check_box {
                                                        border: 1px solid ${colors.customColors.blueColor2};
                                                    }
                                                }

                                                input[type="checkbox"]:checked ~ label {

                                                    .check_box {
                                                        background: ${colors.customColors.blueColor2};
                                                        transition: all 0.4s ease;

                                                        i {
                                                            opacity: 1;
                                                            color: ${colors.customColors.whiteColor};
                                                            transition: all 0.4s ease;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    .top_right {
                                        position: relative;
                                        width: 35px;
                                        height: 35px;
                                        border-radius: 50%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        box-shadow: 0 0 5px ${colors.boxShadowColors.shadowColor1};
                                        margin-left: 20px;

                                        i {
                                            position: relative;
                                            font-size: 14px;
                                            color: ${colors.customColors.blackColor2};
                                            transition: all 0.3s ease;
                                        }
                                    }

                                    &.active {
                                        border-bottom: 1px solid ${colors.customColors.borderColor};

                                        .top_right {
                                            i {
                                                transform: rotate(90deg);
                                                transition: all 0.3s ease;
                                            }
                                        }
                                    }
                                }

                                .bottom_part {
                                    position: relative;
                                    width: 100%;
                                    max-height: 0;
                                    overflow: hidden;
                                    transition: all 0.5s ease;

                                    &.active {
                                        max-height: 1000px;
                                        transition: all 0.5s ease;
                                    }

                                    .bottom_inner {
                                        position: relative;
                                        width: 100%;
                                        padding: 15px;
                                        display: flex;
                                        flex-direction: column;

                                        .table_sec {
                                            position: relative;
                                            width: 100%;

                                            table {
                                                position: relative;
                                                width: 100%;
                                                display: flex;
                                                flex-direction: column;

                                                thead {
                                                    position: relative;
                                                    width: 100%;
                                                    height: 40px;
                                                    background: ${colors.themeColor};
                                                    border-radius: 10px 10px 0px 0px;
                                                    border: 1px solid ${colors.themeColor};

                                                    tr {
                                                        position: relative;
                                                        width: 100%;
                                                        height: 100%;
                                                        display: flex;
                                                    }

                                                    th {
                                                        position: relative;
                                                        height: 100%;
                                                        display: flex;
                                                        align-items: center;
                                                        font-family: "Lemonada", cursive;
                                                        font-size: 12px;
                                                        word-break: break-all;
                                                        color: ${colors.customColors.whiteColor};
                                                        padding: 0 25px;
                                                        font-weight: 600;

                                                        &:nth-of-type(1) {
                                                            width: 40%;
                                                        }
                                                        &:nth-of-type(2) {
                                                            width: 15%;
                                                            justify-content: center;
                                                        }
                                                        &:nth-of-type(3) {
                                                            width: 15%;
                                                            justify-content: center;
                                                        }
                                                        &:nth-of-type(4) {
                                                            width: 15%;
                                                            justify-content: center;
                                                        }
                                                        &:nth-of-type(5) {
                                                            width: 15%;
                                                            justify-content: center;
                                                        }
                                                    }
                                                }

                                                tbody {
                                                    position: relative;
                                                    width: 100%;
                                                    border: 1px solid ${colors.customColors.whiteColor2};
                                                    border-top: none;
                                                    border-radius: 0px 0px 10px 10px;
                                                    display: flex;
                                                    flex-direction: column;
                                                    overflow: hidden;

                                                    tr {
                                                        position: relative;
                                                        width: 100%;
                                                        min-height: 40px;
                                                        display: flex;

                                                        &:nth-of-type(even) {
                                                            background: ${colors.customColors.lightBackground3};
                                                        }

                                                        td {
                                                            position: relative;
                                                            padding: 12px 25px;
                                                            display: flex;
                                                            color: ${colors.customColors.blackColor};
                                                            font-size: 13px;
                                                            word-break: break-all;
                                                            line-height: 1.5;

                                                            &:nth-of-type(1) {
                                                                width: 40%;
                                                                display: flex;
                                                                align-items: flex-start;
                                                            }

                                                            &:nth-of-type(2) {
                                                                width: 15%;
                                                                align-items: center;
                                                                justify-content: center;

                                                                li {
                                                                    position: relative;
                                                                    list-style: none;

                                                                    input[type="checkbox"] {
                                                                        display: none;
                                                                    }

                                                                    label {
                                                                        position: relative;
                                                                        cursor: pointer;
                                                                        line-height: 1;
                                                                        display: flex;
                                                                        align-items: center;

                                                                        .check_box {
                                                                            position: relative;
                                                                            width: 15px;
                                                                            height: 15px;
                                                                            border: 1px solid ${colors.customColors.borderColor};
                                                                            border-radius: 4px;
                                                                            cursor: pointer;
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                position: absolute;
                                                                                left: 2px;
                                                                                bottom: 2px;
                                                                                width: 18px;
                                                                                opacity: 0;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }

                                                                    input[type="checkbox"]:checked ~ label {

                                                                        .check_box {
                                                                            border: 1px solid ${colors.customColors.blackColor1};
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                opacity: 1;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            &:nth-of-type(3) {
                                                                width: 15%;
                                                                align-items: center;
                                                                justify-content: center;

                                                                li {
                                                                    position: relative;
                                                                    list-style: none;

                                                                    input[type="checkbox"] {
                                                                        display: none;
                                                                    }

                                                                    label {
                                                                        position: relative;
                                                                        cursor: pointer;
                                                                        line-height: 1;
                                                                        display: flex;
                                                                        align-items: center;

                                                                        .check_box {
                                                                            position: relative;
                                                                            width: 15px;
                                                                            height: 15px;
                                                                            border: 1px solid ${colors.customColors.borderColor};
                                                                            border-radius: 4px;
                                                                            cursor: pointer;
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                position: absolute;
                                                                                left: 2px;
                                                                                bottom: 2px;
                                                                                width: 18px;
                                                                                opacity: 0;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }

                                                                    input[type="checkbox"]:checked ~ label {

                                                                        .check_box {
                                                                            border: 1px solid ${colors.customColors.blackColor1};
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                opacity: 1;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            &:nth-of-type(4) {
                                                                width: 15%;
                                                                align-items: center;
                                                                justify-content: center;

                                                                li {
                                                                    position: relative;
                                                                    list-style: none;

                                                                    input[type="checkbox"] {
                                                                        display: none;
                                                                    }

                                                                    label {
                                                                        position: relative;
                                                                        cursor: pointer;
                                                                        line-height: 1;
                                                                        display: flex;
                                                                        align-items: center;

                                                                        .check_box {
                                                                            position: relative;
                                                                            width: 15px;
                                                                            height: 15px;
                                                                            border: 1px solid ${colors.customColors.borderColor};
                                                                            border-radius: 4px;
                                                                            cursor: pointer;
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                position: absolute;
                                                                                left: 2px;
                                                                                bottom: 2px;
                                                                                width: 18px;
                                                                                opacity: 0;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }

                                                                    input[type="checkbox"]:checked ~ label {

                                                                        .check_box {
                                                                            border: 1px solid ${colors.customColors.blackColor1};
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                opacity: 1;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            &:nth-of-type(5) {
                                                                width: 15%;
                                                                align-items: center;
                                                                justify-content: center;

                                                                li {
                                                                    position: relative;
                                                                    list-style: none;

                                                                    input[type="checkbox"] {
                                                                        display: none;
                                                                    }

                                                                    label {
                                                                        position: relative;
                                                                        cursor: pointer;
                                                                        line-height: 1;
                                                                        display: flex;
                                                                        align-items: center;

                                                                        .check_box {
                                                                            position: relative;
                                                                            width: 15px;
                                                                            height: 15px;
                                                                            border: 1px solid ${colors.customColors.borderColor};
                                                                            border-radius: 4px;
                                                                            cursor: pointer;
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                position: absolute;
                                                                                left: 2px;
                                                                                bottom: 2px;
                                                                                width: 18px;
                                                                                opacity: 0;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }

                                                                    input[type="checkbox"]:checked ~ label {

                                                                        .check_box {
                                                                            border: 1px solid ${colors.customColors.blackColor1};
                                                                            transition: all 0.4s ease;

                                                                            img {
                                                                                opacity: 1;
                                                                                transition: all 0.4s ease;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const ProfileSettingsWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }
    }

    .tab_sec {
        position: relative;
        margin-top: 25px;
        width: 100%;

        .tab_inner {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            li {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                font-size: 12.5px;
                color: ${colors.customColors.blackColor1};
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    color: ${colors.customColors.whiteColor};
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .heading_option_part {
        position: relative;
        width: 100%;
        padding: 0 15px;
        display: flex;
        margin-top: 20px;

        .inner_part {
            position: relative;
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid ${colors.themeColor};

            .part_box {
                position: relative;
                list-style: none;
                height: 100%;
                padding: 0 20px;
                padding-top: 2px;
                display: flex;
                align-items: center;
                text-decoration: none;
                border-radius: 6px 6px 0 0;
                cursor: pointer;
                transition: all 0.5s ease;
                
                &:hover {
                    color: ${colors.themeColor};
                    transition: all 0.5s ease;
                }
                
                &.active {
                    background: ${colors.themeColor};
                    transition: all 0.5s ease;
                }

                h6 {
                    position: relative;
                    font-size: 12.5px;
                    font-weight: 500;
                    color: ${colors.customColors.blackColor1};
                }
                
                &.active h6 {
                    color: ${colors.customColors.whiteColor};
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .page_contents {
        position: relative;
        width: 100%;
        margin-top: 20px;
    }
`;

export const StudentWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .wrapper_content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;

        .content_box {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            &:last-of-type {
                margin-bottom: 0;
            }

            .box_top_sec {
                position: relative;
                width: 100%;
                display: flex;
                align-items: flex-end;
                padding: 0 15px;
                padding-bottom: 8px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 15px;
                    width: calc(100% - 30px);
                    height: 1px;
                    background: linear-gradient(to right, ${colors.customColors.borderColor1} 20%, transparent 100%);
                }

                .box_head {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    h6 {
                        position: relative;
                        font-size: 15px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor1};
                    }
                    p {
                        position: relative;
                        font-size: 11px;
                        color: ${colors.customColors.blackColor2};
                    }
                }

                .add_btn {
                    position: relative;
                    margin-left: 20px;

                    button {
                        position: relative;
                        width: 175px;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        border: none;
                        background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                        color: ${colors.customColors.whiteColor};
                        border-radius: 6px;
                        font-size: 12.5px;
                        font-weight: 500;
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.5s ease;

                        i {
                            margin-right: 8px;
                            font-size: 12px;
                        }

                        &:hover {
                            border-radius: 25px;
                            transition: all 0.5s ease;
                        }
                    }
                }
            }

            .box_bottom_sec {
                position: relative;
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                padding: 0 5px;

                .sec_item {
                    position: relative;
                    width: 25%;
                    max-width: 302.75px;
                    padding: 10px;

                    .item_inner {
                        position: relative;
                        width: 100%;
                        padding: 12px;
                        padding-left: 15px;
                        background: ${colors.customColors.whiteColor};
                        border: 1px solid ${colors.customColors.borderColor};
                        border-left: 4px solid ${colors.customColors.greenColor};
                        border-radius: 8px;
                        display: flex;
                        flex-direction: column;
                        box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                    -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                        .inner_top {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            padding-bottom: 8px;
                            border-bottom: 1px solid ${colors.customColors.borderColor};

                            a {
                                position: relative;
                                width: 28px;
                                height: 28px;
                                border-radius: 50%;
                                background: ${colors.customColors.greenColorLight};
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 12px;
                                color: ${colors.customColors.greenColor};
                                text-decoration: none;
                                cursor: pointer;
                            }

                            .inner_content {
                                position: relative;
                                width: calc(100% - 28px);
                                display: flex;
                                padding-left: 12px;

                                h6 {
                                    position: relative;
                                    max-width: calc(100% - 85px);
                                    font-size: 13.5px;
                                    font-style: italic;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor};
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                                span {
                                    position: relative;
                                    width: max-content;
                                    display: flex;
                                    font-size: 10px;
                                    color: ${colors.customColors.greenColor};
                                    margin-top: 2px;
                                    background: ${colors.customColors.greenColorLight};
                                    border-radius: 25px;
                                    padding: 3px 15px;
                                    margin-left: auto;
                                    font-weight: 500;
                                }
                            }
                        }

                        .inner_btn {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            margin-top: 8px;
                            justify-content: flex-end;

                            button {
                                position: relative;
                                width: max-content;
                                height: 25px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: none;
                                padding: 0 12px;

                                &.details {
                                    background: ${colors.customColors.blueColorLight};
                                    color: ${colors.customColors.blueColor2};
                                    font-size: 10px;
                                    cursor: pointer;
                                    font-weight: 500;
                                    border-bottom-left-radius: 4px;
                                    border-top-left-radius: 4px;

                                    &.not_removal {
                                        border-bottom-right-radius: 4px;
                                        border-top-right-radius: 4px;
                                    }
                                }

                                &.delete {
                                    background: ${colors.customColors.redColorLight};
                                    color:  ${colors.customColors.redColor};
                                    font-size: 10px;
                                    cursor: pointer;
                                    border-top-right-radius: 4px;
                                    border-bottom-right-radius: 4px;
                                }
                            }
                        }
                    }
                }

                .empty_messege {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 0 10px;
                    margin-top: 15px;

                    img {
                        position: relative;
                        width: 150px;
                        opacity: 0.5;
                    }

                    p {
                        position: relative;
                        font-size: 13px;
                        margin-top: 10px;
                        color: ${colors.customColors.blackColor3};
                    }
                }
            }

            &:hover {
                .box_top_sec {
                    .add_btn {
                        button {
                            opacity: 1;
                            visibility: visible;
                            transition: all 0.5s ease;
                        }
                    }
                }
            }
        }
    }
`;

export const StaffWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .wrapper_content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;

        .content_box {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            &:last-of-type {
                margin-bottom: 0;
            }

            .box_top_sec {
                position: relative;
                width: 100%;
                display: flex;
                align-items: flex-end;
                padding-bottom: 6px;
                padding: 0 15px;
                padding-bottom: 8px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 15px;
                    width: calc(100% - 30px);
                    height: 1px;
                    background: linear-gradient(to right, ${colors.customColors.borderColor1} 20%, transparent 100%);
                }

                .box_head {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    h6 {
                        position: relative;
                        font-size: 15px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor1};
                    }
                    p {
                        position: relative;
                        font-size: 11px;
                        color: ${colors.customColors.blackColor2};
                    }
                }
                
                .add_btn {
                    position: relative;
                    margin-left: 20px;

                    button {
                        position: relative;
                        width: 200px;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                        color: ${colors.customColors.whiteColor};
                        border: none;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.3s ease;
                        
                        &:hover {
                            border-radius: 25px;
                            transition: all 0.3s ease;
                        }

                        i {
                            margin-right: 8px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .box_bottom_sec {
                position: relative;
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                padding: 0 5px;
                margin-top: 10px;

                .sec_item {
                    position: relative;
                    width: 25%;
                    max-width: 302.75px;
                    padding: 10px;

                    .item_inner {
                        position: relative;
                        width: 100%;
                        padding: 12px;
                        padding-left: 15px;
                        background: ${colors.customColors.whiteColor};
                        border: 1px solid ${colors.customColors.borderColor};
                        border-left: 4px solid ${colors.customColors.greenColor};
                        border-radius: 8px;
                        display: flex;
                        flex-direction: column;
                        box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                    -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                        .inner_top {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            padding-bottom: 8px;
                            border-bottom: 1px solid ${colors.customColors.borderColor};

                            a {
                                position: relative;
                                width: 28px;
                                height: 28px;
                                border-radius: 50%;
                                background: ${colors.customColors.greenColorLight};
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 12px;
                                color: ${colors.customColors.greenColor};
                                text-decoration: none;
                                cursor: pointer;
                            }

                            .inner_content {
                                position: relative;
                                width: calc(100% - 28px);
                                display: flex;
                                padding-left: 12px;

                                h6 {
                                    position: relative;
                                    max-width: calc(100% - 85px);
                                    font-size: 13.5px;
                                    font-style: italic;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor};
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                                span {
                                    position: relative;
                                    width: max-content;
                                    display: flex;
                                    font-size: 10px;
                                    color: ${colors.customColors.greenColor};
                                    margin-top: 2px;
                                    background: ${colors.customColors.greenColorLight};
                                    border-radius: 25px;
                                    padding: 3px 15px;
                                    margin-left: auto;
                                    font-weight: 500;
                                }
                            }
                        }

                        .inner_btn {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            margin-top: 8px;
                            justify-content: flex-end;

                            button {
                                position: relative;
                                width: max-content;
                                height: 25px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: none;
                                padding: 0 12px;

                                &.details {
                                    background: ${colors.customColors.blueColorLight};
                                    color: ${colors.customColors.blueColor2};
                                    font-size: 10px;
                                    cursor: pointer;
                                    font-weight: 500;
                                    border-bottom-left-radius: 4px;
                                    border-top-left-radius: 4px;
                                }

                                &.delete {
                                    background: ${colors.customColors.redColorLight};
                                    color:  ${colors.customColors.redColor};
                                    font-size: 10px;
                                    cursor: pointer;
                                    border-top-right-radius: 4px;
                                    border-bottom-right-radius: 4px;
                                }
                            }
                        }
                    }
                }

                .empty_messege {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 0 10px;
                    margin-top: 10px;

                    img {
                        position: relative;
                        width: 150px;
                        opacity: 0.5;
                    }

                    p {
                        position: relative;
                        font-size: 13px;
                        margin-top: 10px;
                        color: ${colors.customColors.blackColor3};
                    }
                }
            }

            &:hover {
                .box_top_sec {
                    .add_btn {
                        button {
                            opacity: 1;
                            visibility: visible;
                            transition: all 0.5s ease;
                        }
                    }
                }
            }
        }
    }
`;

export const SectionFieldsWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 15px;

    .wrapper_content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;

        .content_top {
            position: relative;
            width: 100%;
            display: flex;
            align-items: flex-end;
            padding-bottom: 7px;

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 1px;
                background: linear-gradient(to right, ${colors.customColors.borderColor1} 20%, transparent 100%);
            }

            .box_head {
                position: relative;
                width: 100%;
                display: flex;
                align-items: center;

                h6 {
                    position: relative;
                    font-size: 13px;
                    font-weight: 400;
                    color: ${colors.customColors.blackColor1};
                    
                    &:last-of-type {
                        color: ${colors.customColors.blueColor1};
                    }
                }
                
                span {
                    position: relative;
                    font-size: 10px;
                    color: ${colors.customColors.blackColor1};
                    margin: 0 6px;
                }
            }

            .add_btn {
                position: relative;
                margin-left: 20px;

                button {
                    position: relative;
                    width: 170px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }
                }
            }
        }

        .content_bottom {
            position: relative;
            width: 100%;
            height: calc(100vh - 240px);
            display: flex;
            margin-top: 15px;
            
            .left_content {
                position: relative;
                width: 400px;
                height: 100%;
                padding-right: 15px;
                border-right: 1px solid ${colors.customColors.borderColor};
                overflow-y: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .left_content_inner {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .field_box {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;

                        .field_image {
                            position: relative;
                            width: 11px;
                            display: flex;

                            img {
                                position: relative;
                                width: 100%;
                            }

                            i {
                                position: relative;
                                font-size: 15px;
                                color: ${colors.customColors.blueColor1};
                            }
                        }

                        li {
                            position: relative;
                            width: calc(100% - 21px);
                            height: 100%;
                            margin-left: 10px;
                            padding: 10px 12px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            border: 1px solid ${colors.customColors.borderColor};
                            border-radius: 6px;
                            list-style: none;
                            cursor: pointer;
                            transition: all 0.5s ease;

                            p {
                                font-size: 12px;
                                color: ${colors.customColors.blackColor};
                                font-weight: 400;
                            }

                            i {
                                font-size: 14px;
                                color: ${colors.customColors.blackColor2};
                            }

                            &.active {
                                border: 1px solid ${colors.customColors.blueColor2};
                                background: ${colors.customColors.blueColorLight};
                                transition: all 0.5s ease;

                                p {
                                    color: ${colors.customColors.blueColor2};
                                }

                                i {
                                    color: ${colors.customColors.blueColor2};
                                }
                            }

                            &:hover {
                                background: ${colors.customColors.lightBackground};
                                transition: all 0.5s ease;
                            }
                        }
                    }
                }
            }

            .right_content {
                position: relative;
                width: calc(100% - 400px);
                height: 100%;
                padding-left: 15px;
                overflow-y: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .right_content_inner {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    h6 {
                        position: relative;
                        font-size: 12px;
                        font-weight: 400;
                        font-style: italic;
                        color: ${colors.customColors.blackColor1};
                        
                        span {
                            font-style: normal;
                            color: ${colors.customColors.blackColor};
                        }
                    }

                    .input_field_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-top: 15px;

                        .input_box {
                            position: relative;
                            width: calc(100% - 160px);
                            padding-right: 15px;

                            input {
                                position: relative;
                                width: 100%;
                                height: 37px;
                                border: 1px solid ${colors.customColors.borderColor};
                                font-size: 12px;
                                border-radius: 5px;
                                padding: 5px 15px;
                                outline: none;
                                transition: all 0.5s ease;

                                &:focus,
                                &:valid {
                                    border: 1px solid ${colors.customColors.blackColor};
                                    transition: all 0.5s ease;
                                }
                            }

                            span {
                                position: absolute;
                                top: 50%;
                                left: 15px;
                                padding: 0 5px;
                                font-size: 12px;
                                background: ${colors.customColors.whiteColor};
                                line-height: 1;
                                color: ${colors.customColors.blackColor2};
                                pointer-events: none;
                                transform: translateY(-50%);
                                transition: all 0.5s ease;
                            }

                            input:focus ~ span,
                            input:valid ~ span {
                                transform: translateY(-25px);
                                font-size: 10px;
                                color: ${colors.themeColor};
                                font-weight: 500;
                                transition: all 0.5s ease;
                            }
                        }

                        button {
                            position: relative;
                            width: 160px;
                            height: 37px;
                            font-size: 13px;
                            font-weight: 500;
                            cursor: pointer;
                            border-radius: 6px;
                            overflow: hidden;
                            border: none;
                            background: ${colors.customColors.blueColor1};
                            color: ${colors.customColors.whiteColor};
                            transition: all 0.5s ease;

                            &:hover {
                                border-radius: 25px;
                                transition: all 0.5s ease;
                            }

                            &:disabled {
                                cursor: not-allowed;
                                opacity: 0.4;
                            }
                        }
                    }

                    .item_box {
                        position: relative;
                        width: 100%;
                        margin-top: 15px;

                        .box_content {
                            position: relative;
                            width: 100%;
                            min-height: 80px;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: flex-start;
                            padding: 7px;
                            border: 1px solid ${colors.customColors.blackColor};
                            border-radius: 5px;

                            li {
                                position: relative;
                                width: max-content;
                                display: flex;
                                align-items: center;
                                list-style: none;
                                padding: 5px 5px 5px 10px;
                                border-radius: 4px;
                                background: ${colors.customColors.blueColor1};
                                margin: 3px;

                                p {
                                    position: relative;
                                    font-size: 11px;
                                    color: ${colors.customColors.whiteColor};
                                }

                                span {
                                    position: relative;
                                    font-size: 12px;
                                    color: ${colors.customColors.whiteColor};
                                    margin-left: 6px;
                                    cursor: pointer;
                                }
                            }

                            input {
                                position: relative;
                                margin: 5px;
                                width: max-content;
                                border: none;
                                outline: none;
                                background: transparent;
                                padding: 0 5px;
                                font-size: 11px;
                                height: 23px;
                            }
                        }
                    }

                    .mandatory_sec {
                        position: relative;
                        width: 100%;
                        margin-top: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 10px 15px;
                        border: 1px solid ${colors.customColors.borderColor};
                        border-radius: 6px;

                        p {
                            position: relative;
                            font-size: 12px;
                            color: ${colors.customColors.blackColor1};
                        }

                        .toggle_bar {
                            position: relative;
                            width: 100px;
                            display: flex;
                            justify-content: center;

                            input[type="checkbox"] {
                                display: none;
                            }

                            label {
                                position: relative;
                                width: 40px;
                                height: 21px;
                                background: ${colors.customColors.whiteColor2};
                                border-radius: 25px;
                                padding: 3px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                transition: all 0.5s ease;

                                span {
                                    position: relative;
                                    width: 15px;
                                    height: 100%;
                                    background: ${colors.customColors.whiteColor};
                                    border-radius: 50%;
                                    transition: all 0.5s ease;
                                }
                            }

                            input[type="checkbox"]:checked ~ label {
                                background: ${colors.customColors.greenColor};
                                transition: all 0.5s ease;
                            }

                            input[type="checkbox"]:checked ~ label span {
                                transform: translateX(19px);
                                transition: all 0.5s ease;
                            }
                        }
                    }

                    .remove_btn {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: flex-start;
                        margin-top: 15px;

                        button {
                            position: relative;
                            width: 160px;
                            height: 37px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            font-weight: 500;
                            color: ${colors.customColors.whiteColor};
                            background: ${colors.customColors.redColor};
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            transition: all 0.5s ease;

                            i {
                                margin-right: 8px;
                                font-size: 12px;
                            }

                            &:hover {
                                border-radius: 25px;
                                transition: all 0.5s ease;
                            }
                        }
                    }
                }
            }

            .empty_box {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 35px;
                overflow-y: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                img {
                    position: relative;
                    width: 300px;
                    opacity: 0.5;
                }

                p {
                    position: relative;
                    margin-top: 10px;
                    font-size: 14px;
                    opacity: 0.4;
                }
            }
        }
    }
`;

export const SubjectSettingsWrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }
    }

    .subject_search_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 20px;
        padding: 0 15px;

        .search_sec {
            position: relative;
            height: 35px;
            padding: 5px 0;
            display: flex;
            border: 1px solid ${colors.customColors.borderColor};
            border-radius: 6px;

            i {
                position: relative;
                width: 40px;
                height: 100%;
                font-size: 13px;
                color: ${colors.customColors.blackColor3};
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid ${colors.customColors.borderColor};
            }

            input {
                position: relative;
                width: 300px;
                height: 100%;
                border: none;
                outline: none;
                padding: 0 15px;
                font-size: 12px;
                color: ${colors.customColors.blackColor1};
            }
        }

        .add_btn {
            position: relative;
            margin-left: auto;

            button {
                position: relative;
                width: 200px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                color: ${colors.customColors.whiteColor};
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                border: none;
                transition: all 0.5s ease;
                
                i {
                    margin-right: 8px;
                    font-size: 12px;
                }
                
                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .subjects_levels {
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
        padding: 0 5px;

        .subject_box {
            position: relative;
            width: 25%;
            max-width: 302.75px;
            padding: 10px;

            .box_inner {
                position: relative;
                width: 100%;
                padding: 12px;
                padding-left: 15px;
                background: ${colors.customColors.whiteColor};
                border: 1px solid ${colors.customColors.borderColor};
                border-left: 4px solid ${colors.customColors.blueColor2};
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                .top_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 4px;
                    border-bottom: 1px solid ${colors.customColors.borderColor};

                    .part_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        
                        a {
                            position: relative;
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: ${colors.customColors.blueColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            color: ${colors.customColors.blueColor2};
                            text-decoration: none;
                            cursor: pointer;
                        }
                        
                        h6 {
                            position: relative;
                            padding-left: 8px;
                            max-width: calc(100% - 28px);
                            font-size: 13.5px;
                            font-style: italic;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor};
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }

                    .subject_assigning_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        align-items: flex-start;
                        margin-top: 3px;

                        .title {
                            position: relative;
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                            font-size: 10px;
                            color: ${colors.customColors.blackColor2};
                            padding-top: 2px;

                            i {
                                font-size: 9px;
                                color: ${colors.customColors.blackColor2};
                                margin-right: 5px;
                            }

                            b {
                                font-weight: 500;
                                margin-right: 4px;
                                font-style: italic;
                                color: ${colors.customColors.blackColor1};
                            }
                        }

                        .sections {
                            display: contents;

                            span {
                                position: relative;
                                padding: 2px 7px;
                                background: ${colors.customColors.blueColorLight};
                                border-radius: 25px;
                                border: 1px solid ${colors.customColors.blueColor1};
                                color: ${colors.customColors.blueColor1};
                                margin-right: 4px;
                                margin-bottom: 4px;
                                font-size: 8px;
                            }
                        }
                    }
                }

                .bottom_btn {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-top: 8px;
                    justify-content: flex-end;

                    button {
                        position: relative;
                        width: max-content;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: none;
                        padding: 0 12px;

                        &.details {
                            background: ${colors.customColors.blueColorLight};
                            color: ${colors.customColors.blueColor2};
                            font-size: 10px;
                            cursor: pointer;
                            font-weight: 500;
                            border-bottom-left-radius: 4px;
                            border-top-left-radius: 4px;
                        }

                        &.delete {
                            background: ${colors.customColors.redColorLight};
                            color:  ${colors.customColors.redColor};
                            font-size: 10px;
                            cursor: pointer;
                            border-top-right-radius: 4px;
                            border-bottom-right-radius: 4px;
                        }
                    }
                }
            }
        }
    }

    .empty_box {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        margin-top: 80px;

        img {
            position: relative;
            width: 300px;
            opacity: 0.5;
        }

        p {
            position: relative;
            font-size: 15px;
            margin-top: 10px;
            color: ${colors.customColors.blackColor3};
        }
    }
`;

export const StateCitiesWrapper = styled('div')`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .state_search_sec {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;

        .search_sec {
            position: relative;
            height: 35px;
            padding: 5px 0;
            display: flex;
            border: 1px solid ${colors.customColors.borderColor};
            border-radius: 6px;

            i {
                position: relative;
                width: 40px;
                height: 100%;
                font-size: 13px;
                color: ${colors.customColors.blackColor3};
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid ${colors.customColors.borderColor};
            }

            input {
                position: relative;
                width: 300px;
                height: 100%;
                border: none;
                outline: none;
                padding: 0 15px;
                font-size: 12px;
                color: ${colors.customColors.blackColor1};
            }
        }

        .add_btn {
            position: relative;
            margin-left: auto;
            display: flex;
            align-items: center;

            button {
                position: relative;
                width: 200px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                color: ${colors.customColors.whiteColor};
                border: none;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;
                
                i {
                    margin-right: 8px;
                    font-size: 12px;
                }
                
                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .table_sec {
        position: relative;
        width: 100%;
        margin-top: 30px;
        padding: 0 15px;

        table {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;

            thead {
                position: relative;
                width: 100%;
                height: 40px;
                background: ${colors.themeColor};
                border-radius: 10px 10px 0px 0px;
                border: 1px solid ${colors.themeColor};

                tr {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                th {
                    position: relative;
                    height: 100%;
                    display: flex;
                    -moz-box-align: center;
                    align-items: center;
                    font-family: "Lemonada", cursive;
                    font-size: 12px;
                    word-break: break-all;
                    color: ${colors.customColors.whiteColor};
                    padding: 0 25px;
                    font-weight: 600;

                    &:nth-of-type(1) {
                        width: 25%;
                    }
                    &:nth-of-type(2) {
                        width: 60%;
                    }
                    &:nth-of-type(3) {
                        width: 15%;
                        justify-content: center;
                    }
                }
            }

            tbody {
                position: relative;
                width: 100%;
                border: 1px solid ${colors.customColors.borderColor};
                border-radius: 0px 0px 10px 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                tr {
                    position: relative;
                    width: 100%;
                    min-height: 40px;
                    display: flex;

                    &:nth-of-type(even) {
                        background: ${colors.customColors.blueColorLight};
                    }

                    td {
                        position: relative;
                        display: flex;
                        font-family: "Poppins", sans-serif;
                        font-size: 12px;
                        word-break: break-all;
                        line-height: 1.5;

                        &:nth-of-type(1) {
                            width: 25%;
                            padding: 10px 25px;
                        }
                        &:nth-of-type(2) {
                            width: 60%;
                            padding: 8px 15px;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;

                            li {
                                position: relative;
                                list-style: none;
                                line-height: 1;
                                padding: 6px 12px;
                                margin: 5px;
                                font-size: 11px;
                                height: max-content;
                                background: ${colors.customColors.blueColorLight};
                                border-radius: 20px;
                                border: 1px solid ${colors.customColors.blueColor1};
                            }
                        }
                        &:nth-of-type(3) {
                            width: 15%;
                            padding: 10px 25px;
                            justify-content: center;

                            a {
                                position: relative;
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 13px;

                                &.edit_btn {
                                    color: ${colors.customColors.greenColor};
                                }
                                
                                &.delete_btn {
                                    margin-left: 10px;
                                    color: ${colors.customColors.redColor};
                                }
                            }   
                        }

                        &.empty_message {
                            position: relative;
                            width: 100%;
                            padding: 12px 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor2};
                        }
                    }
                }
            }
        }
    }
`;

export const TimeTableSettingsWrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .add_btn {
            position: relative;
            margin-left: auto;

            button {
                position: relative;
                width: 200px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border: none;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                color: ${colors.customColors.whiteColor};
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;
                
                i {
                    margin-right: 8px;
                    font-size: 12px;
                }
                
                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .slot_levels {
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
        padding: 0 5px;

        .slot_box {
            position: relative;
            width: 25%;
            max-width: 302.75px;
            padding: 10px;

            .box_inner {
                position: relative;
                width: 100%;
                padding: 12px;
                padding-left: 15px;
                background: ${colors.customColors.whiteColor};
                border: 1px solid ${colors.customColors.borderColor};
                border-left: 4px solid ${colors.customColors.blueColor2};
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                .top_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 8px;
                    border-bottom: 1px solid ${colors.customColors.borderColor};

                    .part_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        
                        a {
                            position: relative;
                            width: 30px;
                            height: 30px;
                            border-radius: 10px;
                            background: ${colors.customColors.blueColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            color: ${colors.customColors.blueColor2};
                            text-decoration: none;
                            cursor: pointer;
                        }

                        li {
                            position: relative;
                            list-style: none;
                            padding-left: 8px;
                            max-width: calc(100% - 28px);
                            display: flex;
                            flex-direction: column;

                            h6 {
                                position: relative;
                                width: 100%;
                                font-size: 13px;
                                font-style: italic;
                                font-weight: 500;
                                color: ${colors.customColors.blackColor};
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            p {
                                position: relative;
                                margin-top: 2px;
                                font-size: 11px;
                                color: ${colors.customColors.blackColor2};
                            }
                        }
                    }
                }

                .bottom_btn {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: flex-end;
                    margin-top: 7px;

                    .time_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        margin-right: auto;

                        p {
                            position: relative;
                            font-size: 11.5px;
                            color: ${colors.customColors.blackColor2};
                            font-style: italic;

                            span {
                                position: relative;
                                color: ${colors.customColors.blackColor};
                                font-style: normal;
                            }
                        }
                    }

                    button {
                        position: relative;
                        width: max-content;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: none;
                        padding: 0 12px;

                        &.details {
                            background: ${colors.customColors.blueColorLight};
                            color: ${colors.customColors.blueColor2};
                            font-size: 10px;
                            cursor: pointer;
                            font-weight: 500;
                            border-bottom-left-radius: 4px;
                            border-top-left-radius: 4px;

                            i {
                                font-size: 12px;
                                margin-right: 4px;
                            }
                        }

                        &.delete {
                            background: ${colors.customColors.redColorLight};
                            color:  ${colors.customColors.redColor};
                            font-size: 10px;
                            cursor: pointer;
                            border-top-right-radius: 4px;
                            border-bottom-right-radius: 4px;
                        }
                    }
                }
            }
        }

        .empty_box {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 50px;
            overflow-y: auto;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }

            img {
                position: relative;
                width: 350px;
                opacity: 0.5;
            }

            p {
                position: relative;
                margin-top: 15px;
                font-size: 13px;
                color: ${colors.customColors.blackColor2};
            }
        }
    }

    .page_bottom_sec {
        position: sticky;
        top: 74px;
        z-index: 20;
        background: ${colors.customColors.whiteColor};
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        padding-top: 15px;
        margin-top: 15px;

        &::before {
            position: absolute;
            content: "";
            top: 0;
            left: 15px;
            width: calc(100% - 30px);
            height: 1px;
            background: ${colors.customColors.borderColor};
        }

        .schedule_head {
            position: relative;
            width: 100%;
            display: flex;

            h2 {
                position: relative;
                font-size: 21px;
                font-weight: 600;
                color: ${colors.customColors.blackColor};
                font-family: "SUSE", sans-serif;
            }
        }

        .bottom_desc {
            position: relative;
            font-size: 12px;
            color: ${colors.customColors.blackColor2};
            margin-top: 6px;
        }

        .page_items_sec {
            position: relative;
            width: 100%;
            display: flex;
            margin-top: 30px;

            .left_item_sec {
                position: sticky;
                top: 15px;
                align-self: flex-start;
                width: 300px;
                padding-right: 20px;
                display: flex;
                flex-direction: column;

                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    height: 100%;
                    background: ${colors.customColors.borderColor};
                }

                .left_item_inner {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .select_box {
                        position: relative;
                        width: 100%;
                        margin-bottom: 15px;

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-weight: 400;
                            color: ${colors.customColors.blackColor2};

                            p {
                                color: ${colors.customColors.redColor};
                                margin-left: 2px;
                            }
                        }

                        .dropdown_sec {
                            position: relative;
                            width: 100%;
                            height: 37px;
                            flex-direction: column;
                            margin-top: 3px;

                            .dropdown_btn {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                border-radius: 5px;
                                padding: 5px 15px;
                                cursor: pointer;
                                background: ${colors.customColors.lightBackground3};

                                p {
                                    position: relative;
                                    width: calc(100% - 25px);
                                    display: flex;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor1};
                                }

                                i {
                                    position: relative;
                                    margin-left: auto;
                                    display: flex;
                                    justify-content: flex-end;
                                    cursor: pointer;
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor2};
                                    transition: all 0.5s ease;
                                    
                                    &.active {
                                        transform: rotate(-180deg);
                                        transition: all 0.5s ease;
                                    }
                                }
                            }

                            .dropdown {
                                position: absolute;
                                top: 100%;
                                left: 0px;
                                width: 100%;
                                z-index: 15;
                                background: ${colors.customColors.whiteColor};
                                border-radius: 5px;
                                box-shadow: 5px 8px 15px ${colors.boxShadowColors.shadowColor1};
                                max-height: 0px;
                                overflow: hidden;
                                transition: all 0.5s ease;

                                &.active {
                                    max-height: 200px;
                                    transition: all 0.5s ease;
                                }

                                .dropdown_inner {
                                    position: relative;
                                    width: 100%;
                                    padding: 10px;
                                    display: flex;
                                    flex-direction: column;

                                    ul {
                                        position: relative;
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;
                                        max-height: 160px;
                                        overflow-y: auto;
                                        scrollbar-width: none;
                                        -ms-overflow-style: none;

                                        &::-webkit-scrollbar {
                                            display: none;
                                        }

                                        li {
                                            position: relative;
                                            width: 100%;
                                            list-style: none;
                                            padding: 7px 15px;
                                            cursor: pointer;
                                            font-size: 12px;
                                            color: ${colors.customColors.blackColor1};
                                            border-radius: 4px;
                                            transition: all 0.5s ease;

                                            &:hover {
                                                background: ${colors.themeColor};
                                                color: ${colors.customColors.whiteColor};
                                                transition: all 0.5s ease;
                                            }

                                            &.active {
                                                background: ${colors.customColors.lightBackground};
                                                color: ${colors.customColors.blackColor};

                                                &:hover {
                                                    color: ${colors.customColors.blackColor};
                                                }
                                            }

                                            &.empty_message {
                                                padding: 5px 10px;
                                                color: ${colors.customColors.blackColor3};
                                                pointer-events: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .subject_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 12px;

                        a {
                            position: relative;
                            font-size: 12px;
                            color: ${colors.customColors.blackColor1};
                            font-size: 500;
                            text-decoration: none;
                        }

                        .subject_items {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            margin-top: 8px;

                            .item {
                                position: relative;
                                padding-right: 6px;
                                padding-bottom: 6px;
                                display: flex;

                                span {
                                    position: relative;
                                    width: max-content;
                                    font-size: 10px;
                                    color: ${colors.customColors.blueColor2};
                                    padding: 3px 10px;
                                    background: ${colors.customColors.blueColorLight};
                                    border: 1px solid ${colors.customColors.blueColor2};
                                    border-radius: 25px;
                                }
                            }

                            p {
                                position: relative;
                                font-size: 12px;
                                color: ${colors.customColors.blackColor3};
                            }
                        }
                    }

                    .weekday_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        border-top: 1px solid ${colors.customColors.borderColor};

                        h5 {
                            position: relative;
                            font-size: 13px;
                            color: ${colors.customColors.blackColor};
                            font-weight: 500;
                        }

                        .day_type_sec {
                            position: relative;
                            width: 100%;
                            display: flex;
                            flex-direction: column;

                            .day_box {
                                position: relative;
                                margin-top: 10px;
                                width: 100%;
                                display: flex;
                                flex-direction: column;

                                p {
                                    position: relative;
                                    font-size: 11px;
                                    color: ${colors.customColors.blackColor1};
                                    font-weight: 500;
                                }

                                ul {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-items: center;
                                    margin-top: 6px;

                                    li {
                                        position: relative;
                                        padding-right: 6px;
                                        padding-bottom: 6px;
                                        display: flex;
                                        list-style: none;

                                        span {
                                            position: relative;
                                            padding: 3px 10px;
                                            font-size: 10px;
                                            color: ${colors.customColors.blackColor};
                                            background: ${colors.customColors.borderColor};
                                            border-radius: 25px;
                                            cursor: pointer;

                                            &.active {
                                                color: ${colors.customColors.whiteColor};
                                                background: ${colors.customColors.greenColor};
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .toggle_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        margin-bottom: 15px;
                        border-top: 1px solid ${colors.customColors.borderColor};
                        padding-top: 15px;

                        .toggle_bar {
                            position: relative;
                            width: max-content;
                            display: flex;
                            justify-content: flex-start;
                            margin-left: auto;

                            input[type="checkbox"] {
                                display: none;
                            }

                            label {
                                position: relative;
                                width: 40px;
                                height: 21px;
                                background: ${colors.customColors.whiteColor2};
                                border-radius: 25px;
                                padding: 3px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                transition: all 0.5s ease;

                                span {
                                    position: relative;
                                    width: 15px;
                                    height: 100%;
                                    background: ${colors.customColors.whiteColor};
                                    border-radius: 50%;
                                    transition: all 0.5s ease;
                                }
                            }

                            input[type="checkbox"]:checked ~ label {
                                background: ${colors.customColors.greenColor};
                                transition: all 0.5s ease;
                            }

                            input[type="checkbox"]:checked ~ label span {
                                transform: translateX(19px);
                                transition: all 0.5s ease;
                            }
                        }

                        p {
                            position: relative;
                            font-size: 12px;
                            color: ${colors.customColors.blackColor1};
                        }
                    }

                    .text_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        margin-bottom: 20px;
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding: 13px;
                        background: ${colors.customColors.lightBackground3};
                        border-radius: 5px;
                        
                        .text_top_sec {
                            position: relative;
                            width: 100%;
                            min-height: 60px;
                            display: flex;
                            flex-wrap: wrap;

                            .repeat_data {
                                position: relative;
                                height: max-content;
                                display: flex;
                                align-items: center;
                                font-size: 10px;
                                color: ${colors.customColors.blackColor1};
                                margin-bottom: 5px;
                                padding: 4px 4px 4px 14px;;
                                border-radius: 25px;
                                border: 1px solid ${colors.customColors.borderColor};
                                background: ${colors.customColors.whiteColor};

                                &:last-of-type {
                                    margin-bottom: 0;
                                }

                                p {
                                    position: relative;

                                }

                                &.empty_message {
                                    padding: 0 5px;
                                    border: none;
                                    background: transparent;
                                    font-size: 11px;
                                    color: ${colors.customColors.blackColor2};
                                }

                                .btns {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    margin-left: 15px;


                                    a {
                                        position: relative;
                                        width: 20px;
                                        height: 20px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        font-size: 9.5px;
                                        color: ${colors.customColors.whiteColor};
                                        cursor: pointer;
                                        text-decoration: none;

                                        &:first-of-type {
                                            background: ${colors.customColors.greenColor};
                                            border-top-left-radius: 4px;
                                            border-bottom-left-radius: 4px;
                                        }

                                        &:last-of-type {
                                            width: 24px;
                                            background: ${colors.customColors.redColor};
                                            border-top-right-radius: 25px;
                                            border-bottom-right-radius: 25px;
                                            padding-right: 2px;
                                        }
                                    }
                                }
                            }
                        }

                        .text_bottom_sec {
                            position: relative;
                            width: 100%;
                            display: flex;
                            margin-top: 7px;
                            padding-top: 7px;
                            border-top: 1px solid ${colors.customColors.borderColor};
                            justify-content: flex-end;

                            button {
                                position: relative;
                                padding: 5px 12px;
                                font-size: 10px;
                                font-weight: 400;
                                color: ${colors.customColors.whiteColor};
                                background: ${colors.customColors.blueColor2};
                                border: none;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.5s ease;

                                &:hover {
                                    border-radius: 25px;
                                    transition: all 0.5s ease;
                                }
                            }
                        }
                    }

                    .btn_box {
                        position: relative;

                        button {
                            position: relative;
                            width: 100%;
                            height: 37px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            font-weight: 500;
                            color: ${colors.customColors.whiteColor};
                            background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                            border: none;
                            border-radius: 5px;
                            cursor: pointer;
                            transition: all 0.5s ease;

                            i {
                                margin-right: 8px;
                                font-size: 13px;
                            }

                            &:hover {
                                border-radius: 25px;
                                transition: all 0.5s ease;
                            }

                            &:disabled {
                                opacity: 0.4;
                                cursor: not-allowed;
                                transition: all 0.5s ease;
                            }
                        }
                    }
                }
            }

            .right_item_sec {
                position: relative;
                width: calc(100% - 300px);
                padding-left: 20px;
                padding-right: 8px;
                display: flex;
                max-height: calc(100vh - 70px);
                overflow-y: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                .time_levels {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .time_level_box {
                        position: relative;
                        width: 100%;
                        margin: 10px 0;
                        display: flex;
                        flex-direction: column;
                        border-radius: 8px;
                        box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                    -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                        .box_head {
                            position: relative;
                            width: 100%;
                            padding: 20px 20px 10px 20px;
                            display: flex;
                            align-items: flex-end;

                            &::before {
                                content: '';
                                position: absolute;
                                left: 20px;
                                bottom: 0;
                                width: calc(100% - 40px);
                                height: 1px;
                                background: ${colors.customColors.borderColor};
                            }

                            li {
                                position: relative;
                                display: flex;
                                align-items: center;
                                list-style: none;

                                i {
                                    position: relative;
                                    width: 32px;
                                    height: 32px;
                                    background: ${colors.customColors.blueColorLight};
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border-radius: 10px;
                                    font-size: 14px;
                                    color: ${colors.customColors.blueColor3};
                                }

                                span {
                                    position: relative;
                                    margin-left: 8px;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: ${colors.customColors.blackColor};
                                    margin-top: 0;
                                }
                            }

                            .header_btn_sec {
                                position: relative;
                                margin-left: auto;

                                button {
                                    position: relative;
                                    height: 30px;
                                    padding: 0 20px;
                                    border: none;
                                    font-size: 12px;
                                    margin-left: 10px;
                                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                                    color: ${colors.customColors.whiteColor};
                                    border-radius: 6px;
                                    cursor: pointer;
                                    opacity: 0;
                                    visibility: hidden;
                                    transition: all 0.5s ease;
    
                                    i {
                                        margin-right: 6px;
                                    }
    
                                    &:hover {
                                        border-radius: 25px;
                                        transition: all 0.5s ease;
                                    }
    
                                    &.small_btn {
                                        padding: 0 15px;
    
                                        i {
                                            margin-right: 0;
                                        }
                                    }

                                    &:disabled {
                                        opacity: 0.4;
                                        cursor: not-allowed;
                                    }
                                }
                            }

                        }

                        .box_items {
                            position: relative;
                            width: 100%;
                            display: flex;
                            padding: 10px;
                            flex-wrap: wrap;

                            .class_item {
                                position: relative;
                                width: 33.33%;
                                max-width: 280px;
                                padding: 10px;

                                .item_inner {
                                    position: relative;
                                    width: 100%;
                                    padding: 12px;
                                    padding-left: 15px;
                                    background: ${colors.customColors.blueColorLight1};
                                    border: 1px solid ${colors.customColors.borderColor};
                                    border-left: 4px solid ${colors.customColors.blueColor2};
                                    border-radius: 8px;
                                    display: flex;
                                    flex-direction: column;
                                    box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                                                -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                                    .timing {
                                        position: relative;
                                        width: max-content;
                                        display: flex;
                                        align-items: center;
                                        border: 1px solid ${colors.customColors.borderColor};
                                        padding: 4px 10px;
                                        background: ${colors.customColors.whiteColor1};
                                        box-shadow: 3px 3px 5px ${colors.boxShadowColors.shadowColor2};
                                        border-radius: 6px;

                                        i {
                                            font-size: 10px;
                                            color: ${colors.customColors.blueColor2};
                                        }
                                        
                                        p {
                                            position: relative;
                                            margin-left: 5px;
                                            font-size: 11px;
                                            letter-spacing: 0.44px;
                                            color: ${colors.customColors.blueColor2};
                                        }
                                    }

                                    .content_part {
                                        position: relative;
                                        margin-top: 12px;
                                        width: 100%;
                                        display: flex;
                                        align-items: center;

                                        img {
                                            position: relative;
                                            width: 32px;
                                            height: auto;
                                        }

                                        li {
                                            position: relative;
                                            width: calc(100% - 32px);
                                            list-style: none;
                                            display: flex;
                                            flex-direction: column;
                                            padding-left: 10px;

                                            h6 {
                                                position: relative;
                                                width: 100%;
                                                font-size: 13.5px;
                                                font-weight: 500;
                                                color: ${colors.customColors.blackColor};
                                            }

                                            span {
                                                position: relative;
                                                font-size: 12px;
                                                line-height: 1.2;
                                                color: ${colors.customColors.blackColor2};
                                            }
                                        }
                                    }

                                    .teacher_info {
                                        position: relative;
                                        width: 100%;
                                        margin-top: 8px;
                                        padding-top: 6px;
                                        border-top: 1px solid ${colors.customColors.borderColor};
                                        display: flex;
                                        align-items: center;

                                        i {
                                            position: relative;
                                            width: 10px;
                                            font-size: 11px;
                                            color: ${colors.customColors.blueColor2};
                                        }

                                        a {
                                            position: relative;
                                            width: calc(100% - 16px);
                                            font-size: 12px;
                                            margin-left: 6px;
                                            color: ${colors.customColors.blueColor2};
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                        }
                                    }
                                }
                            }
                        }

                        &:hover {
                            .box_head {
                                a {
                                    opacity: 1;
                                    visibility: visible;
                                    transition: all 0.5s ease;
                                }

                                button {
                                    opacity: 1;
                                    visibility: visible;
                                    transition: all 0.5s ease;
                                }
                            }
                        }
                    }

                    .btns_sec {
                        position: relative;
                        width: 100%;
                        display: flex;
                        margin-top: 20px;
                        justify-content: flex-end;

                        button {
                            position: relative;
                            width: 150px;
                            height: 35px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            font-weight: 500;
                            border: none;
                            border-radius: 5px;
                            cursor: pointer;
                            transition: all 0.5s ease;

                            i {
                                margin-right: 8px;
                            }

                            &:hover {
                                border-radius: 25px;
                                transition: all 0.5s ease;
                            }

                            &.regenerate_btn {
                                border: 2px solid ${colors.customColors.blueColor2};
                                background: ${colors.customColors.whiteColor};
                                color: ${colors.customColors.blueColor2};
                            }

                            &.save_btn {
                                margin-left: 20px;
                                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                                color: ${colors.customColors.whiteColor};

                                &:disabled {
                                    opacity: 0.4;
                                    cursor: not-allowed;
                                }
                            }
                        }
                    }
                }

                .empty_box {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding-top: 35px;

                    img {
                        position: relative;
                        width: 250px;
                        opacity: 0.5;
                    }

                    p {
                        position: relative;
                        margin-top: 25px;
                        font-size: 13px;
                        color: ${colors.customColors.blackColor2};
                    }
                }
            }
        }
    }
`;

export const SubscriptionSettingWrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;

    .page_head {
        position: relative;
        width: 100%;
        display: flex;
        padding: 0 15px;

        h2 {
            position: relative;
            font-size: 21px;
            font-weight: 600;
            color: ${colors.customColors.blackColor};
            font-family: "SUSE", sans-serif;
        }

        .edit_btn {
            position: relative;
            margin-left: auto;

            button {
                position: relative;
                width: 200px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                color: ${colors.customColors.whiteColor};
                border: none;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.5s ease;
                
                i {
                    margin-right: 8px;
                    font-size: 12px;
                }
                
                &:hover {
                    border-radius: 25px;
                    transition: all 0.5s ease;
                }
            }
        }
    }

    .institution_subscription_section {
        position: relative;
        margin-top: 25px;
        width: 100%;
        padding: 0 5px;
        display: flex;
        flex-wrap: wrap;

        .subscription_box {
            position: relative;
            width: 25%;
            max-width: 302.75px;
            max-height: 135px;
            padding: 10px;

            .box_inner {
                position: relative;
                width: 100%;
                padding: 12px;
                padding-left: 15px;
                background: ${colors.customColors.whiteColor};
                border: 1px solid ${colors.customColors.borderColor};
                border-left: 4px solid ${colors.customColors.blueColor1};
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                box-shadow: 4px 4px 10px ${colors.boxShadowColors.shadowColor2},
                            -2px -2px 5px ${colors.boxShadowColors.shadowColor2};

                .top_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 8px;
                    border-bottom: 1px solid ${colors.customColors.borderColor};

                    .part_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        
                        a {
                            position: relative;
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: ${colors.customColors.blueColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            color: ${colors.customColors.blueColor1};
                            text-decoration: none;
                            cursor: pointer;
                        }
                        
                        h6 {
                            position: relative;
                            padding-left: 12px;
                            max-width: calc(100% - 85px);
                            font-size: 13.5px;
                            font-style: italic;
                            font-weight: 500;
                            color: ${colors.customColors.blackColor};
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        span {
                            position: relative;
                            width: max-content;
                            display: flex;
                            font-size: 10px;
                            color: ${colors.customColors.greenColor};
                            margin-top: 2px;
                            background: ${colors.customColors.greenColorLight};
                            border-radius: 25px;
                            padding: 3px 15px;
                            margin-left: auto;
                            font-weight: 500;
                        }
                    }

                    .duration_name {
                        position: relative;
                        width: 100%;
                        display: flex;
                        margin-top: 5px;

                        p {
                            position: relative;
                            display: flex;
                            width: 100%;
                            font-size: 12px;
                            color: ${colors.customColors.blackColor1};
                        }
                    }
                }

                .bottom_part {
                    position: relative;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-top: 8px;

                    h5 {
                        position: relative;
                        font-size: 13px;
                        font-weight: 500;
                        color: ${colors.customColors.blackColor};
                        line-height: 1;

                        span {
                            margin-left: 2px;
                            color: ${colors.customColors.blueColor4};
                            font-weight: 400;
                            font-size: 11px;
                        }
                    }

                    .bottom_btn {
                        position: relative;
                        display: flex;
                        margin-left: auto;

                        button {
                            position: relative;
                            width: max-content;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: none;
                            padding: 0 12px;

                            &.edit {
                                background: ${colors.customColors.blueColorLight};
                                color: ${colors.customColors.blueColor2};
                                font-size: 10px;
                                cursor: pointer;
                                font-weight: 500;
                                border-bottom-left-radius: 4px;
                                border-top-left-radius: 4px;
                            }

                            &.delete {
                                background: ${colors.customColors.redColorLight};
                                color:  ${colors.customColors.redColor};
                                font-size: 10px;
                                cursor: pointer;
                                border-top-right-radius: 4px;
                                border-bottom-right-radius: 4px;
                            }
                        }
                    }
                }
            }
        }
    }

    .pricing_section {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        padding-top: 25px;

        &::before {
            position: absolute;
            content: "";
            top: 0;
            left: 15px;
            width: calc(100% - 30px);
            height: 1px;
            background: ${colors.customColors.borderColor};
        }

        .price_top_sec {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0 15px;

            .sec_head {
                position: relative;
                display: flex;
                flex-direction: column;

                h3 {
                    position: relative;
                    font-size: 21px;
                    font-weight: 600;
                    color: ${colors.customColors.blackColor};
                    font-family: "SUSE", sans-serif;
                    line-height: 1;
                }

                p {
                    position: relative;
                    font-size: 13px;
                    color: ${colors.customColors.blackColor2};
                    margin-top: 5px;
                }
            }

            .pricing_option_part {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: auto;

                .inner_part {
                    position: relative;
                    width: max-content;
                    padding: 6px;
                    background: ${colors.customColors.lightBackground};
                    border-radius: 6px;
                    display: flex;

                    .part_box {
                        position: relative;
                        padding: 8px 20px;
                        cursor: pointer;
                        border-radius: 4px;
                        text-decoration: none;
                        display: flex;
                        align-items: center;
                        color: ${colors.customColors.blackColor1};
                        
                        &.active {
                            background: ${colors.customColors.whiteColor};
                            box-shadow: 3px 4px 8px ${colors.boxShadowColors.shadowColor1}, -3px -3px 6px ${colors.boxShadowColors.shadowColor2};
                            color: ${colors.customColors.blueColor2};
                        }

                        span {
                            position: relative;
                            font-size: 12px;
                            font-weight: 500;
                        }
                    }
                }
            }

            .add_btn {
                position: relative;
                margin-left: 15px;

                button {
                    position: relative;
                    padding: 0 15px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                    border: none;
                    color: ${colors.customColors.whiteColor};
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    transition: all 0.5s ease;

                    &:hover {
                        border-radius: 25px;
                        transition: all 0.5s ease;
                    }

                    i {
                        margin-right: 8px;
                        font-size: 12px;
                    }
                }
            }
        }

        .pricing_box_sec {
            position: relative;
            width: 100%;
            display: flex;
            padding: 0 5px;
            margin-top: 20px;

            .price_box {
                position: relative;
                width: 33.33%;
                display: flex;
                padding: 10px;

                &:nth-of-type(2) {
                    .box_inner {
                        .box_top {
                            a {
                                background: ${colors.customColors.greenColorLight};
                                color: ${colors.customColors.greenColor1};
                            }
                        }
                    }
                }
                &:nth-of-type(3) {
                    .box_inner {
                        .box_top {
                            a {
                                background: ${colors.customColors.yellowColorLight};
                                color: ${colors.customColors.orangeColor};
                            }
                        }
                    }
                }
                &:nth-of-type(4) {
                    .box_inner {
                        .box_top {
                            a {
                                background: ${colors.customColors.blueColor2};
                                color: ${colors.customColors.whiteColor};
                            }
                        }
                    }
                }

                .box_inner {
                    position: relative;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding: 15px;
                    border: 1px solid ${colors.customColors.borderColor};
                    border-radius: 6px;

                    .box_top {
                        position: relative;
                        width: 100%;
                        display: flex;

                        a {
                            position: relative;
                            width: 40px;
                            height: 40px;
                            border-radius: 5px;
                            background: ${colors.customColors.blueColorLight};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 14px;
                            color: ${colors.customColors.blueColor3};
                            text-decoration: none;
                        }

                        span {
                            position: relative;
                            display: flex;
                            align-items: center;
                            height: max-content;
                            margin-left: auto;
                            padding: 4px 20px;
                            font-size: 12px;
                            background: linear-gradient(45deg, ${colors.customColors.blueColor1}, ${colors.customColors.blueColor3});
                            color: ${colors.customColors.whiteColor};
                            border-radius: 5px;
                            cursor: pointer;

                            i {
                                margin-right: 5px;
                            }
                        }
                    }

                    .box_content {
                        position: relative;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        margin-top: 10px;

                        h5 {
                            position: relative;
                            font-size: 16px;
                            color: ${colors.customColors.blackColor};
                            font-weight: 500;
                        }

                        p {
                            position: relative;
                            font-size: 12px;
                            color: ${colors.customColors.blackColor1};
                            margin-top: 5px;
                            line-height: 1.5;
                        }

                        .price_sec {
                            position: relative;
                            width: 100%;
                            margin-top: 10px;

                            h6 {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: flex-end;
                                line-height: 1;
                                font-size: 23px;
                                font-weight: 600;
                                color: ${colors.customColors.blueColor3};

                                span {
                                    position: relative;
                                    letter-spacing: 1px;
                                    font-size: 10px;
                                    color: ${colors.customColors.blackColor2};
                                    margin-left: 5px;
                                }
                            }
                        }

                        .addon_sec {
                            position: relative;
                            width: 100%;
                            margin-top: 10px;
                            flex-direction: column;

                            li {
                                position: relative;
                                width: 100%;
                                display: flex;
                                align-items: center;
                                list-style: none;
                                margin-bottom: 8px;
                                padding-bottom: 5px;
                                border-bottom: 1px solid ${colors.customColors.borderColor1};

                                &:last-of-type {
                                    margin-bottom: 0;
                                }

                                p {
                                    font-size: 12px;
                                    color: ${colors.customColors.blackColor1};
                                }

                                a {
                                    position: relative;
                                    margin-left: auto;
                                    text-decoration: none;
                                    color: ${colors.customColors.blackColor};
                                    font-size: 14px;
                                    font-weight: 600;
                                }

                                &:last-of-type {
                                    border-bottom: none;
                                }
                            }
                        }

                        .toggle_sec {
                            position: relative;
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            margin-top: 10px;

                            .sec_box {
                                position: relative;
                                width: 50%;
                                display: flex;
                                padding: 5px;
                            
                                .sec_box_inner {
                                    position: relative;
                                    width: 100%;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                    padding: 15px;
                                    border: 1px solid ${colors.customColors.borderColor};
                                    border-radius: 6px;

                                    a {
                                        position: relative;
                                        width: 35px;
                                        height: 35px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border-radius: 50%;
                                        background: ${colors.customColors.blueColorLight};
                                        font-size: 15px;
                                        color: ${colors.customColors.blueColor2};
                                        text-decoration: none;
                                    }

                                    h4 {
                                        font-size: 13px;
                                        color: ${colors.customColors.blackColor};
                                        font-weight: 500;
                                        margin-top: 4px;
                                    }

                                    p {
                                        font-size: 11px;
                                        color: ${colors.customColors.blackColor2};
                                        font-weight: 400;
                                        margin-top: 2px;
                                        margin-bottom: 4px;
                                    }

                                    .toggle_bar {
                                        position: relative;
                                        width: 50px;
                                        display: flex;

                                        input[type="radio"] {
                                            display: none;
                                        }

                                        label {
                                            position: relative;
                                            width: 40px;
                                            height: 21px;
                                            background: ${colors.customColors.whiteColor2};
                                            border-radius: 25px;
                                            padding: 3px;
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                            transition: all 0.5s ease;

                                            span {
                                                position: relative;
                                                width: 15px;
                                                height: 100%;
                                                background: ${colors.customColors.whiteColor};
                                                border-radius: 50%;
                                                transition: all 0.5s ease;
                                            }
                                        }

                                        input[type="radio"]:checked ~ label {
                                            background: ${colors.customColors.blueColor1};
                                            transition: all 0.5s ease;
                                        }

                                        input[type="radio"]:checked ~ label span {
                                            transform: translateX(19px);
                                            transition: all 0.5s ease;
                                        }
                                    }
                                }

                                &:nth-of-type(2) {
                                    .sec_box_inner {
                                        a {
                                            background: ${colors.customColors.yellowColorLight};
                                            color: ${colors.customColors.yellowColor};
                                        }
                                    }
                                }

                                &:nth-of-type(3) {
                                    .sec_box_inner {
                                        a {
                                            background: ${colors.customColors.violetLight};
                                            color: ${colors.customColors.violet};
                                        }
                                    }
                                }
                                &:nth-of-type(4) {
                                    .sec_box_inner {
                                        a {
                                            background: ${colors.customColors.greenColorLight};
                                            color: ${colors.customColors.greenColor};
                                        }
                                    }
                                }
                            }
                        }

                        ul {
                            position: relative;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            margin-top: 8px;

                            a {
                                position: relative;
                                padding: 3px 15px;
                                margin-right: 10px;
                                text-decoration: none;
                                font-size: 11px;
                                color: ${colors.customColors.blackColor};
                                border-radius: 25px;
                                background: ${colors.customColors.blueColorLight};

                                &:last-of-type {
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
            }
        }

        .table_sec {
            position: relative;
            width: 100%;
            margin-top: 25px;
            padding: 0 15px;

            table {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: column;

                thead {
                    position: relative;
                    width: 100%;
                    height: 40px;
                    background: ${colors.themeColor};
                    border-radius: 10px 10px 0px 0px;
                    border: 1px solid ${colors.themeColor};

                    tr {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        display: flex;
                    }

                    th {
                        position: relative;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        font-family: "Lemonada", cursive;
                        font-size: 12px;
                        word-break: break-all;
                        color: ${colors.customColors.whiteColor};
                        padding: 0 25px;
                        font-weight: 600;

                        &:nth-of-type(1) {
                            width: 30%;
                        }

                        &:nth-of-type(2) {
                            width: 15%;
                            justify-content: center;
                        }

                        &:nth-of-type(3) {
                            width: 25%;
                        }

                        &:nth-of-type(4) {
                            width: 20%;
                            justify-content: center;
                        }

                        &:nth-of-type(5) {
                            width: 10%;
                            justify-content: center;
                        }
                    }
                }

                tbody {
                    position: relative;
                    width: 100%;
                    border: 1px solid ${colors.customColors.whiteColor2};
                    border-top: none;
                    border-radius: 0px 0px 10px 10px;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;

                    tr {
                        position: relative;
                        width: 100%;
                        min-height: 40px;
                        display: flex;

                        &:nth-of-type(even) {
                            background: ${colors.customColors.blueColorLight};
                        }

                        td {
                            position: relative;
                            padding: 12px 25px;
                            display: flex;
                            color: ${colors.customColors.blackColor};
                            font-size: 12px;
                            word-break: break-all;
                            line-height: 1.5;

                            &:nth-of-type(1) {
                                width: 30%;
                                display: flex;
                            }

                            &:nth-of-type(2) {
                                width: 15%;
                                align-items: center;
                                justify-content: center;
                            }

                            &:nth-of-type(3) {
                                width: 25%;
                                display: flex;
                                flex-direction: column;

                                p {
                                    position: relative;
                                    font-size: 12px;
                                    font-weight: 500;
                                    line-height: 1;
                                    display: flex;
                                    align-items: center;
                                    color: ${colors.customColors.blackColor};
                                    
                                    span {
                                        color: ${colors.customColors.blackColor1};
                                        margin-left: 3px;
                                    }
                                }
                            }

                            &:nth-of-type(4) {
                                width: 20%;
                                align-items: center;
                                justify-content: center;
                            }

                            &:nth-of-type(5) {
                                width: 10%;
                                align-items: center;
                                justify-content: center;

                                a {
                                    position: relative;
                                    text-decoration: none;
                                    cursor: pointer;
                                    font-size: 13px;

                                    &.edit_btn {
                                        color: ${colors.customColors.greenColor};
                                        margin: 0 10px;
                                    }

                                    &.delete_btn {
                                        color: ${colors.customColors.redColor};
                                    }
                                }
                            }

                            &.empty_message {
                                position: relative;
                                width: 100%;
                                padding: 12px 25px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 13px;
                                color: ${colors.customColors.blackColor2};
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const AccountSettingWrapper = styled('div')`
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 10px 12px;
    color: #24334b;

    h2, h3, p { margin: 0; }
    button, input { font: inherit; }
    button { cursor: pointer; }

    .account_heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 20px;
        .eyebrow { color: #71819b; font-size: 9px; font-weight: 700; letter-spacing: 1.6px; }
        h2 { margin: 5px 0 6px; font-size: 25px; font-weight: 700; letter-spacing: -0.6px; }
        p { color: #758196; font-size: 12px; line-height: 1.6; }
        .heading_icon { display: grid; place-items: center; width: 44px; height: 44px; border: 1px solid #e4eaf3; border-radius: 13px; color: #4e74b5; background: #f8faff; flex-shrink: 0; }
    }

    .profile_banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 20px 24px;
        margin-bottom: 20px;
        border: 1px solid #dce7f6;
        border-radius: 16px;
        background: radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 65%), linear-gradient(110deg, #f0f9ff, #f8faff);
        .profile_identity { display: flex; align-items: center; gap: 16px; min-width: 0; }
        .profile_avatar {
            width: 68px; height: 68px; flex-shrink: 0; border-radius: 20px;
            display: grid; place-items: center; overflow: hidden;
            background: linear-gradient(140deg, #209cdb, #5b67d6); color: white;
            border: 3px solid white; box-shadow: 0 4px 12px #4c74ac26; font-size: 23px; font-weight: 600;
            img { width: 100%; height: 100%; object-fit: cover; }
        }
        .profile_summary { min-width: 0; overflow-wrap: anywhere; }
        h3 { font-size: 18px; font-weight: 650; }
        p { color: #6b7b94; font-size: 12px; margin: 3px 0 8px; }
        .role_badge { display: inline-flex; align-items: center; gap: 5px; background: #fff; border: 1px solid #dfe7f6; padding: 4px 8px; border-radius: 6px; font-size: 10px; font-weight: 600; color: #5066a4; }
        .account_status {
            display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0;
            font-size: 10px; font-weight: 600; padding: 6px 10px; border-radius: 20px;
            background: #ffffffb8; border: 1px solid #d8e8e4; color: #28765d;
            > span { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
            &.inactive { color: #846633; border-color: #e8dcc6; }
        }
    }

    .settings_card { border: 1px solid #e4e9f1; border-radius: 12px; margin-bottom: 14px; background: #fff; overflow: hidden; box-shadow: 0 2px 5px #23395803; }
    .section_heading {
        display: flex; align-items: center; gap: 10px; padding: 15px 18px; border-bottom: 1px solid #edf0f5;
        h3 { font-size: 13px; font-weight: 650; }
        p { margin-top: 3px; font-size: 11px; color: #7b8799; line-height: 1.5; }
        .section_icon { display: grid; place-items: center; flex-shrink: 0; width: 32px; height: 32px; border-radius: 9px; background: #edf6ff; color: #3485bf; font-size: 13px; }
        .security_icon { background: #f0edfc; color: #7b64bb; }
    }
    .visibility_button { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; margin-left: auto; padding: 7px 9px; border: 1px solid #e4e9f1; border-radius: 7px; background: #fff; color: #65758c; font-size: 10px; }
    .fields_grid {
        display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; padding: 18px;
        &.institution_fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        label { display: flex; flex-direction: column; gap: 7px; font-size: 11px; font-weight: 600; color: #526178; min-width: 0; }
        input { box-sizing: border-box; width: 100%; min-width: 0; height: 40px; padding: 0 12px; border: 1px solid #dfe5ee; border-radius: 7px; background: #fbfcfe; color: #293b53; font-size: 12px; font-weight: 400; transition: border-color 150ms, box-shadow 150ms; }
        input::placeholder { color: #98a3b3; }
        input:focus { outline: none; border-color: #62a7e0; background: #fff; box-shadow: 0 0 0 3px #299bea14; }
    }
    .form_actions {
        display: flex; align-items: center; justify-content: space-between; gap: 14px; padding-top: 6px;
        p { display: flex; align-items: center; gap: 7px; font-size: 10px; color: #8490a1; }
        > div { display: flex; gap: 9px; }
        button { display: inline-flex; align-items: center; justify-content: center; gap: 7px; height: 38px; padding: 0 17px; border-radius: 8px; font-size: 11px; font-weight: 600; }
        .reset_button { background: white; border: 1px solid #dfe5ee; color: #607087; }
        .save_button { background: linear-gradient(120deg, #208fd0, #4475ce); border: 1px solid #3183c8; color: white; box-shadow: 0 3px 8px #287bc125; }
        .save_button:hover { filter: brightness(0.95); }
        .reset_button:hover { background: #f4f7fb; }
    }
    button:focus-visible { outline: 2px solid #398ed1; outline-offset: 3px; }
    @media (max-width: 1000px) {
        .fields_grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .section_heading { flex-wrap: wrap; }
        .visibility_button { margin-left: 42px; }
    }
    @media (max-width: 600px) {
        padding: 0;
        .account_heading h2 { font-size: 22px; }
        .profile_banner { padding: 16px; flex-wrap: wrap; }
        .profile_banner .account_status { margin-left: 84px; }
        .fields_grid, .fields_grid.institution_fields { grid-template-columns: 1fr; padding: 15px; }
        .form_actions { align-items: stretch; flex-direction: column; }
        .form_actions > div { justify-content: flex-end; }
    }
`;
